import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import print from 'vue3-print-nb'
import * as echarts from 'echarts'

const app = createApp(App)
app.config.globalProperties.$echarts = echarts

app.use(ElementPlus)
app.use(print)
app.use(store).use(router).mount('#app')
